import React from 'react';
import Stack from 'atoms/Layout/Stack/Stack';
import HeadingAndSupportingText from 'molecules/HeadingAndSupportingText/HeadingAndSupportingText';
import { TypographyProps } from 'atoms/Typography/Typography';

const HeroBannerTextBlock = (): JSX.Element => {
  const renderTextBlock = (textAlign: TypographyProps['textAlign']): JSX.Element => (
    <HeadingAndSupportingText
      gap='spacing-3xl'
      heading={{
        text: 'The Community Platform That Delivers',
        type: 'heading',
        size: '2xl',
        letterSpacing: -1,
        textAlign,
      }}
      supportingText={{
        text: 'Community. Courses. Events. $500M earned on Mighty in 2025.',
        type: 'paragraph',
        size: 'xl',
        textAlign,
      }}
    />
  );

  return (
    <Stack
      padding={['spacing-none', 'spacing-4xl']}
      paddingSm={['spacing-none', 'spacing-xl']}
    >
      <Stack
        maxWidth='width-xl'
        margin={['spacing-none', 'spacing-auto']}
      >
        <Stack hideOn='sm'>{renderTextBlock('center')}</Stack>
        <Stack showOn='sm'>{renderTextBlock('left')}</Stack>
      </Stack>
    </Stack>
  );
};

export default HeroBannerTextBlock;
